import styles from './click-away-listener.module.scss';
import MaterialClickAwayListener from '@mui/material/ClickAwayListener';

/* eslint-disable-next-line */
export interface ClickAwayListenerProps {
  children: any,
  onClickAway?: any,
  // disableReactTree?: boolean,
  // mouseEvent?: 'onClick' | 'onMouseDown' | 'onMouseUp' | false,
  // touchEvent?: 'onTouchEnd' | 'onTouchStart' | false
}

export function ClickAwayListener(props: ClickAwayListenerProps) {
  return (
    <MaterialClickAwayListener
      onClickAway={props.onClickAway}>
      <div>
        {props.children}
      </div>
    </MaterialClickAwayListener>
  );
}

export default ClickAwayListener;